import React from 'react';
import PropTypes from 'prop-types';
import { getImage } from 'gatsby-plugin-image';

export default function SvgWithImage(props) {
  const { img, width = 300, height = 300 } = props;
  const currentImage = getImage(img);
  const imageUrl = currentImage.images.fallback.src;
  return (
    <div className="">
      <svg
        width={width}
        height={height}
        id="Layer_3"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 2998 2766"
      >
        <defs>
          <clipPath id="shape">
            <path d="M670.69,742.15c-29.57,148.19-69.6,347.87-105.4,523.41-68.72,336.95,56.26,550.6,445.99,445.99,491.58-131.94,337.86,312.07,432.26,432.26,48.01,61.12,144.06,54.96,199.02,0l389.49-389.49c8.42-8.42,15.74-17.88,21.78-28.15l530.3-901.39c32.52-55.27,34.01-139.26-21.78-170.87-104.14-59-264.71-150.29-419.89-238.73" />

            <path d="M2145.74,415.93h-194.47c-14.72,0-29.39,1.87-43.64,5.56L670.61,742.13" />
          </clipPath>
        </defs>
        <path
          style={{ fill: 'none', stroke: '#fff', strokeMiterlimit: '10', strokeWidth: '8px' }}
          d="M1907.63,421.5L656.47,745.8c-76.72,19.88-130.29,89.11-130.29,168.36v658.42c0,55.22-4,156.28,95.57,255.86,111.92,111.92,309.92,232.55,484.51,260.03,640.81,100.87,562.34,392.46,734.66,542.16,36.6,31.79,125.82,45.06,184.94,13.62l687.84-365.81c56.78-30.2,92.26-89.25,92.26-153.56V589.86c0-96.06-77.87-173.93-173.93-173.93h-680.76c-14.72,0-29.39,1.87-43.64,5.56Z"
        />
        <path
          style={{ fill: 'none', stroke: '#fff', strokeMiterlimit: '10', strokeWidth: '8px' }}
          d="M255.69,1419.76c-84.93,416.44,69.53,680.48,551.2,551.2,607.54-163.07,417.56,385.69,534.22,534.22,59.33,75.54,178.05,67.92,245.97,0l481.37-481.37c10.41-10.41,19.46-22.1,26.92-34.79l655.39-1114.02c40.19-68.31,42.03-172.11-26.92-211.18-228.03-129.19-674.99-383.64-915.92-521.87-48.36-27.74-86.48-62.94-139.91-49-268.79,70.14-811.45,212-1087.56,286.8-64.64,17.51-120.83,57.1-140.4,121.15,0,0-101.37,511.9-184.36,918.86Z"
        />
        <path
          style={{ fill: 'none', stroke: '#fff', strokeMiterlimit: '10', strokeWidth: '8px' }}
          d="M565.3,1265.56c-68.72,336.95,56.26,550.6,445.99,445.99,491.58-131.94,337.86,312.07,432.26,432.26,48.01,61.12,144.06,54.96,199.02,0l389.49-389.49c8.42-8.42,15.74-17.88,21.78-28.15l530.3-901.39c32.52-55.27,34.01-139.26-21.78-170.87-184.5-104.53-546.16-310.41-741.1-422.26-39.13-22.45-69.97-50.93-113.2-39.65-217.48,56.75-656.57,171.53-879.98,232.05-52.3,14.17-97.77,46.2-113.6,98.02,0,0-82.02,414.19-149.17,743.48Z"
        />
        <image xlinkHref={imageUrl} width="69%" clipPath="url(#shape)" x="18%" y="6%"/>
      </svg>
    </div>
  );
}

SvgWithImage.propTypes = {
  img: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  width: PropTypes.number,
  height: PropTypes.number,
};
